import React from "react";
import AboutSection from "./AboutSection";
import FeatureCard from "./FeatureCard";
import Ball from "../../assets/images/svg/americanFootball 1.svg";
import ring from "../../assets/images/svg/ring.svg";
import trophy from "../../assets/images/svg/trophy.svg";
import medal from "../../assets/images/svg/medal.svg";
import Team from "./Team";
import team from "../../assets/images/svg/team1.svg";
import team2 from "../../assets/images/svg/adebare.svg";
import team3 from "../../assets/images/svg/jimmy.svg";
import team4 from "../../assets/images/svg/azeez.svg";
import team5 from "../../assets/images/svg/adebare1.svg";
import team6 from "../../assets/images/svg/jimmi1.svg";
import SHTSpinner from "../../components/SHTSpinner";
import AboutHeader from "./AboutHeader";

const details = [
  {
    id: 0,
    image: Ball,
    head: "SHOWTIME CUP",
    title: "Winner of Showtime takes the cup ",
  },
  {
    id: 1,
    image: ring,
    head: "SHOWTIME RING",
    title: "Winner of Showtime takes the ring ",
  },
  {
    id: 2,
    image: trophy,
    head: "AWARDS",
    title: "Best players in the league get awards",
  },
  {
    id: 3,
    image: medal,
    head: "MEDALS",
    title: "Second runner up wins Gold medals",
  },
];

const teamDetails = [
  {
    id: 0,
    name: "AZEEZ AMIDA",
    post: "OWNER",
    image: team,
  },
  {
    id: 1,
    name: "ADEBARE",
    post: "COMMISSIONER",
    image: team2,
  },
  {
    id: 2,
    name: "JIMMIE NEWTRON",
    post: "MEDIA HEAD",
    image: team3,
  },
  {
    id: 3,
    name: "AZEEZ AMIDA",
    post: "OWNER",
    image: team4,
  },
  {
    id: 4,
    name: "ADEBARE",
    post: "COMMISSIONER",
    image: team5,
  },
  {
    id: 5,
    name: "JIMMIE NEWTRON",
    post: "MEDIA HEAD",
    image: team6,
  },
];
const AboutPage = () => {
  return (
    <SHTSpinner loading={false}>
      <AboutHeader />
      <AboutSection />
      <FeatureCard trophyDetails={details} />
      <Team teamDetails={teamDetails} />
    </SHTSpinner>
  );
};

export default AboutPage;
